import React from "react";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import LctNumber from "../../../custom/Number";
import { newColumn, newColumnDateByMoment, newColumnText } from "../TableList";

const newColumnMoneyByUserTaxResidence = (title, field, options = {}) => ({
  ...newColumn(title, field, "numeric", "right", (rowData) => {
    const value = rowData[field];

    if (value === null || value === undefined) {
      return null;
    }

    return <LctNumber value={value} currency="LCT" taxResidence={rowData.userTaxResidence} grouping={false} locale="en" />;
  }),
  ...options,
});

const newColumnPayableByUserTaxResidence = (title, options = {}) => ({
  ...newColumn(title, "amount", "numeric", "right", (rowData) => {
    if (rowData.payable === null || rowData.payable === undefined) {
      return null;
    }

    return <LctNumber value={rowData.payable} currency="LCT" taxResidence={rowData.userTaxResidence} grouping={false} locale="en" />;
  }),
  ...options,
});

export const TAB_PENDING = 0;
export const TAB_HISTORY = 1;
export const TAB_WAITING_AUTH = 2;
export const TAB_REDEMPTIONS = 3;

export const DATE_FILTER_ENUM = {
  TODAY: "TODAY",
  FUTURE: "FUTURE",
  DELAYED: "DELAYED",
};

export const EMPTY_WITHDRAWAL_FILTERS = {
  nameOrEmail: "",
  userId: "",
  withdrawId: "",
  maxAmount: "",
  paymentId: "",
  paymentType: "",
  contractId: "",
  maxValue: "",
  userTaxResidence: "",
  contractStatusRedeemPaid: "",
  partnerWithdraw: "",
  taxResidence: "",
  status: "",
  dateFilter: "",
};

export const TAB_STATUS_MAP = {
  [TAB_PENDING]: ["PENDING"],
  [TAB_HISTORY]: ["APPROVED", "REJECTED", "CANCELED"],
  [TAB_WAITING_AUTH]: ["WAITING_AUTH"],
  [TAB_REDEMPTIONS]: [],
};

export const CONTRACT_STATUS_REDEEM_PAID_OPTIONS = [
  { label: "app.all", value: "" },
  { label: "app.enuns.EMPTY", value: "EMPTY" },
  { label: "app.enuns.WITHOUT_PAY", value: "WITHOUT_PAY" },
  { label: "app.enuns.PAYMENT_GENERATED", value: "PAYMENT_GENERATED" },
  { label: "app.enuns.PAID", value: "PAID" },
];

export const PARTNER_WITHDRAW_OPTIONS = [
  { label: "app.all", value: "" },
  { label: "app.customer", value: "0" },
  { label: "app.partner", value: "1" },
  { label: "app.reaport", value: "2" },
  { label: "AltaVista", value: "3" },
];

export const DATE_FILTER_OPTIONS = [
  { label: "app.all", value: "" },
  { label: "app.delayed", value: DATE_FILTER_ENUM.DELAYED },
  { label: "app.expiration.today", value: DATE_FILTER_ENUM.TODAY },
  { label: "app.no.time", value: DATE_FILTER_ENUM.FUTURE },
];

export const STATUS_FILTER_OPTIONS = [
  { label: "app.all", value: "" },
  { label: "app.enuns.APPROVED", value: "APPROVED" },
  { label: "app.enuns.CANCELED", value: "CANCELED" },
  { label: "app.enuns.REJECTED", value: "REJECTED" },
];

export const TAX_RESIDENCE_FILTER_OPTIONS = [
  { label: "app.all", value: "" },
  { label: "app.taxResidence.Brasil", value: "Brasil" },
  { label: "app.taxResidence.Colômbia", value: "Colômbia" },
  { label: "app.taxResidence.Argentina", value: "Argentina" },
  { label: "app.taxResidence.Austrália", value: "Austrália" },
  { label: "app.taxResidence.Uruguai", value: "Uruguai" },
  { label: "app.taxResidence.Chile", value: "Chile" },
  { label: "app.taxResidence.Venezuela", value: "Venezuela" },
  { label: "app.taxResidence.México", value: "México" },
  { label: "app.taxResidence.Equador", value: "Equador" },
  { label: "app.taxResidence.Índia", value: "Índia" },
  { label: "app.taxResidence.Nova Zelândia", value: "Nova Zelândia" },
  { label: "app.taxResidence.Panamá", value: "Panamá" },
  { label: "app.taxResidence.EUA", value: "EUA" },
  { label: "app.taxResidence.Costa Rica", value: "Costa Rica" },
  { label: "app.taxResidence.Guernsey", value: "Guernsey" },
  { label: "app.taxResidence.Espanha", value: "Espanha" },
  { label: "app.taxResidence.França", value: "França" },
  { label: "app.taxResidence.Reino Unido", value: "Reino Unido" },
  { label: "app.taxResidence.Irlanda", value: "Irlanda" },
  { label: "app.taxResidence.Suíça", value: "Suíça" },
  { label: "app.taxResidence.Itália", value: "Itália" },
  { label: "app.taxResidence.Alemanha", value: "Alemanha" },
  { label: "app.taxResidence.Grécia", value: "Grécia" },
  { label: "app.taxResidence.Países Baixos", value: "Países Baixos" },
  { label: "app.taxResidence.Bélgica", value: "Bélgica" },
  { label: "app.taxResidence.Hungria", value: "Hungria" },
  { label: "app.taxResidence.Chipre", value: "Chipre" },
  { label: "app.taxResidence.Luxemburgo", value: "Luxemburgo" },
  { label: "app.taxResidence.Suécia", value: "Suécia" },
  { label: "app.taxResidence.Emirados Árabes", value: "Emirados Árabes" },
  { label: "app.taxResidence.Peru", value: "Peru" },
  { label: "app.taxResidence.Paraguai", value: "Paraguai" },
];

export const TAB_DIALOG_FIELDS = {
  [TAB_PENDING]: [
    { key: "partnerWithdraw", caption: "app.withdraw.destination", options: PARTNER_WITHDRAW_OPTIONS },
    { key: "dateFilter", caption: "app.date.filter", options: DATE_FILTER_OPTIONS },
    { key: "taxResidence", caption: "app.taxResidence", options: TAX_RESIDENCE_FILTER_OPTIONS },
  ],
  [TAB_HISTORY]: [
    { key: "partnerWithdraw", caption: "app.withdraw.destination", options: PARTNER_WITHDRAW_OPTIONS },
    { key: "status", caption: "app.status", options: STATUS_FILTER_OPTIONS },
    { key: "taxResidence", caption: "app.taxResidence", options: TAX_RESIDENCE_FILTER_OPTIONS },
  ],
  [TAB_WAITING_AUTH]: [{ key: "partnerWithdraw", caption: "app.withdraw.destination", options: PARTNER_WITHDRAW_OPTIONS }],
  [TAB_REDEMPTIONS]: [],
};

export const TAB_SUPPORTS_FILTER_DIALOG = {
  [TAB_PENDING]: true,
  [TAB_HISTORY]: true,
  [TAB_WAITING_AUTH]: true,
  [TAB_REDEMPTIONS]: false,
};

export const BACKEND_SORT_FIELD_MAP = {
  id: "id",
  createdAt: "createdAt",
  authorizeDate: "authorizeDate",
  amount: "amount",
  status: "status",
  withdrawDate: "withdrawDate",
  updatedAt: "updatedAt",
  "account.user.name": "name",
  "account.user.email": "email",
  "account.user.taxResidence": "taxResidence",
  "user.name": "name",
  "user.email": "email",
  "user.taxResidence": "taxResidence",
};

export const TABLE_PAGING = {
  paging: true,
  paginationType: "normal",
  pageSize: 10,
  pageSizeOptions: [10, 25, 50],
};

export const TABLE_LOCALIZATION = {
  body: {
    emptyDataSourceMessage: "app.withdrawals.no",
  },
  header: {
    actions: "",
  },
};

export const sortLocalData = (list, orderBy, orderDirection) => {
  if (!orderBy || !orderBy.field) return list;

  const direction = orderDirection === "asc" ? 1 : -1;
  const field = orderBy.field;

  const getValue = (item) => {
    if (field.includes(".")) {
      return field.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), item);
    }
    return item[field];
  };

  return [...list].sort((a, b) => {
    const va = getValue(a);
    const vb = getValue(b);

    if (va === vb) return 0;
    if (va === null || va === undefined) return 1;
    if (vb === null || vb === undefined) return -1;

    if (typeof va === "number" && typeof vb === "number") {
      return (va - vb) * direction;
    }

    return String(va).localeCompare(String(vb)) * direction;
  });
};

export const tableColumnsPending = () => [
  newColumnText("id", "id"),
  newColumnText("app.name", "userName"),
  newColumnText("app.email", "userEmail"),
  newColumnText("app.taxResidence", "userTaxResidence"),
  newColumnDateByMoment("app.data.order", "createdAt"),
  newColumnDateByMoment("app.confirmed", "authorizeDate", { defaultSort: "asc" }),
  newColumn("app.limit.days", "authorizeDate", "numeric", "center", (row) => row.daysToLimit),
  newColumnMoneyByUserTaxResidence("app.amount.requested", "amount"),
  newColumnPayableByUserTaxResidence("app.amount.payable"),
  newColumn("app.withdraw.destination", "partnerWithdraw", "string", "center", (row) => buildPartnerLabel(row)),
];

export const tableColumnsHistory = () => [
  newColumnText("id", "id"),
  newColumnText("app.name", "userName"),
  newColumnText("app.email", "userEmail"),
  newColumnText("app.taxResidence", "userTaxResidence"),
  newColumnDateByMoment("app.data.order", "createdAt"),
  newColumnDateByMoment("app.confirmed", "authorizeDate"),
  newColumn("app.status", "status", "string", "center", (row) => (row.status ? <FormattedMessage id={`app.enuns.${row.status}`} /> : "")),
  newColumnDateByMoment("app.enuns.APPROVED", "withdrawDate"),
  newColumnDateByMoment("app.rejected", "rejectedDate"),
  newColumnDateByMoment("app.enuns.CANCELED", "canceledDate"),
  newColumn("app.limit.days", "authorizeDate", "numeric", "center", (row) => row.daysToLimit, { sorting: false }),
  newColumnMoneyByUserTaxResidence("app.amount.requested", "amount"),
  newColumn("app.withdraw.destination", "partnerWithdraw", "string", "center", (row) => buildPartnerLabel(row)),
];

export const TABLE_COLUMNS_INTENTIONS = [
  newColumnText("id", "id"),
  newColumnText("app.name", "userName"),
  newColumnText("app.email", "userEmail"),
  newColumnText("app.taxResidence", "userTaxResidence"),
  newColumnDateByMoment("app.data.order", "createdAt"),
  newColumnMoneyByUserTaxResidence("app.amount.requested", "amount"),
  newColumn("app.status", "status", "string", "center", (row) => (row.status ? <FormattedMessage id={`app.enuns.${row.status}`} /> : "")),
  newColumn("app.withdraw.destination", "partnerWithdraw", "string", "center", (row) => buildPartnerLabel(row)),
];

export const TABLE_COLUMNS_REDEMPTIONS = [
  newColumnText("id", "contractId"),
  newColumnText("app.name", "userName"),
  newColumnText("app.email", "userEmail"),
  newColumnText("app.taxResidence", "userTaxResidence"),
  newColumnMoneyByUserTaxResidence("app.amount.requested", "paymentValue"),
  newColumn("app.redemption", "contractStatusRedeemPaid", "string", "center", (row) => (row.contractStatusRedeemPaid ? <FormattedMessage id={`app.enuns.${row.contractStatusRedeemPaid}`} /> : "")),
  newColumn("app.phase", "contractPhase", "string", "center", (row) => (row.contractPhase ? <FormattedMessage id={`app.enuns.${row.contractPhase}`} /> : "")),
  newColumn("app.status", "contractStatus", "string", "center", (row) => (row.contractStatus ? <FormattedMessage id={`app.enuns.${row.contractStatus}`} /> : "")),
  newColumnDateByMoment("app.payday", "paymentDate"),
];

const NETWORK_LABEL_BY_PARTNER_WITHDRAW_TYPE = {
  0: "BTC/BTC",
  1: "USDT/TRX",
  2: "USDT/ETH",
  3: "ETH/ETH",
  4: "USDT/BSC",
  5: "USDC/ETH",
  6: "USDC/TRX",
  7: "USDT/POL",
  8: "USDC/POL",
  9: "POL/POL",
};

export const buildPartnerLabel = (row) => {
  const partnerWithdraw = Number(row.partnerWithdraw);
  const partnerWithdrawType = Number(row.partnerWithdrawType ?? row.partnerwithdrawtype);

  if (partnerWithdraw === 0) {
    return NETWORK_LABEL_BY_PARTNER_WITHDRAW_TYPE[partnerWithdrawType] || row.addressNetwork || row.partnerWithdrawType || "-";
  }

  if (partnerWithdraw === 1) return <FormattedMessage id="app.withdraw.partner" />;
  if (partnerWithdraw === 2)
    return (
      <Typography variant="caption" color="primary">
        <FormattedMessage id="app.reaport" />
      </Typography>
    );
  if (partnerWithdraw === 3) return <>AltaVista</>;
  if (partnerWithdraw === 4) return <FormattedMessage id="app.withdraw.bankingchannel.optionlabel" />;

  return null;
};
